module.exports = ".pull-right{float:right}.spinnerContainer{display:flex;justify-content:center;margin-top:50px}\n"